import { capitalize as e, isArray as t, isEqual as n, isPlainObject as r, merge as i } from "lodash-es";
import a, { Component as o, createElement as s, useEffect as c, useMemo as l, useRef as u } from "react";
import { createStore as d } from "zustand/vanilla";
import { CPage as f, ENGEnvEnum as p, InnerComponentNameEnum as m, checkPage as h, getRandomStr as g, isAction as _, isExpression as v, isFunction as y, isNodeModel as ee, isPropModel as b, isSlotModel as te } from "@chamn/model";
import { htmlTagNames as ne } from "html-tag-names";
import re from "loadjs";
//#region src/core/adapter.ts
var ie = (e) => () => {
	console.warn(`${e} need to be implement getComponent`);
}, ae = ["customPageRootRender"], x = [
	"pageRender",
	"getPageStorage",
	"updatePageStorage",
	"render",
	"convertModelToComponent",
	"getComponent",
	"getContext",
	"getUtils",
	"transformProps",
	"errorCatch",
	"requestAPI",
	"clear"
], oe = (e) => [...x, ...ae].reduce((t, n) => (e?.[n] ? t[n] = e[n]?.bind(e) : x.includes(n) && (t[n] = ie), t), {}), se = (e, t = {
	keyListVar: "ALL_NODE_IDS",
	getReadValCode: ""
}) => {
	let n = e;
	return n[0] === String(Number(n[0])) && (n = `_${n}`), `
var ${e} = {};

${t.keyListVar}.forEach(function (key) {
  var tempK = /^\\d/.test(key) ? ('_' + key) : key;
  Object.defineProperty(${e}, tempK, {
    get: function () {
      ${t.getReadValCode}
    },
    set: function (value) {},
    enumerable: true
  });
});
`;
}, ce = 500, S = /* @__PURE__ */ new Map(), C = (e) => {
	let t = S.get(e);
	if (t) return t;
	let n = 2166136261, r = 5381;
	for (let t = 0; t < e.length; t += 1) {
		let i = e.charCodeAt(t);
		n = Math.imul(n ^ i, 16777619), r = Math.imul(r ^ i, 33);
	}
	let i = `${(n >>> 0).toString(36)}-${(r >>> 0).toString(36)}-${e.length.toString(36)}`;
	return S.size >= ce && S.delete(S.keys().next().value), S.set(e, i), i;
}, w = "ChameleonCodeMapMsg", T = {
	STORE_CHANGED: "store changed: {storeName}",
	STATE_KEYS_UPDATED: "state keys updated: {storeName} [{changedKeys}]",
	STORE_ADDED: "store added: {storeName}",
	STORE_REMOVED: "store removed: {storeName}",
	STORE_MANAGER_DESTROYED: "store manager destroyed",
	STATE_SNAPSHOT_CACHE_HIT: "state snapshot cache hit",
	STATE_SNAPSHOT_CACHE_MISS: "state snapshot cache miss",
	CHILD_ELEMENT_CACHE_HIT: "child element cache hit: {nodeId}",
	CHILD_ELEMENT_CACHE_MISS: "child element cache miss: {nodeId}",
	RENDER_PAGE_RENDERED: "page rendered",
	RENDER_PAGE_RERENDER: "page rerender",
	RENDER_ADAPTER_CLEARED: "adapter cleared",
	CODE_EXECUTOR_COMPILE_BEFORE: "code executor compile before: {cacheKey}",
	CODE_EXECUTOR_COMPILE_AFTER: "code executor compile after: {cacheKey}",
	CODE_EXECUTOR_CACHE_HIT: "code executor cache hit: {cacheKey}"
}, E = "[chameleon/render]", D = {
	STORE_CHANGED: "STORE_CHANGED",
	STATE_KEYS_UPDATED: "STATE_KEYS_UPDATED",
	STORE_ADDED: "STORE_ADDED",
	STORE_REMOVED: "STORE_REMOVED",
	STORE_MANAGER_DESTROYED: "STORE_MANAGER_DESTROYED",
	STATE_SNAPSHOT_CACHE_HIT: "STATE_SNAPSHOT_CACHE_HIT",
	STATE_SNAPSHOT_CACHE_MISS: "STATE_SNAPSHOT_CACHE_MISS",
	CHILD_ELEMENT_CACHE_HIT: "CHILD_ELEMENT_CACHE_HIT",
	CHILD_ELEMENT_CACHE_MISS: "CHILD_ELEMENT_CACHE_MISS",
	RENDER_PAGE_RENDERED: "RENDER_PAGE_RENDERED",
	RENDER_PAGE_RERENDER: "RENDER_PAGE_RERENDER",
	RENDER_ADAPTER_CLEARED: "RENDER_ADAPTER_CLEARED",
	CODE_EXECUTOR_COMPILE_BEFORE: "CODE_EXECUTOR_COMPILE_BEFORE",
	CODE_EXECUTOR_COMPILE_AFTER: "CODE_EXECUTOR_COMPILE_AFTER",
	CODE_EXECUTOR_CACHE_HIT: "CODE_EXECUTOR_CACHE_HIT"
}, le = !1, O = T, k, ue = (e, t) => t ? e.replace(/\{(\w+)\}/g, (e, n) => n in t ? String(t[n]) : e) : e, de = (e) => {
	le = e?.enabled === !0;
	let t = e?.codeMapMsg;
	if (!t || t === k) return;
	if (k = t, typeof t != "string") {
		O = {
			...T,
			...t
		};
		return;
	}
	if (typeof document > "u") {
		console.warn(`${E} cannot load code map message without a document`, { source: t });
		return;
	}
	let n = document.createElement("script");
	n.src = t, n.async = !0, n.onload = () => {
		let e = globalThis[w], n = e?.default || e?.CODE_MAP_MSG;
		if (n) {
			n && k === t && (O = {
				...T,
				...n
			});
			return;
		}
		console.warn(`${E} code map message global not found`, {
			source: t,
			globalName: w
		});
	}, n.onerror = (e) => {
		console.warn(`${E} failed to load code map message`, {
			source: t,
			error: e
		});
	}, document.head.appendChild(n);
}, A = (e, t) => {
	if (!le) return;
	let n = ue(O[e] || e, t);
	if (t === void 0) {
		console.log(`${E}[${e}] ${n}`);
		return;
	}
	console.log(`${E}[${e}] ${n}`, t);
}, fe = 500, j = /* @__PURE__ */ new Map(), M = (e) => {
	if (!e) {
		j.clear();
		return;
	}
	let t = `${e}:`;
	Array.from(j.keys()).filter((e) => e.startsWith(t)).forEach((e) => j.delete(e));
}, pe = function(e) {
	return !(!e || typeof e != "function" || !e.prototype);
};
function N(e) {
	let t = e?.prototype;
	return !!(t && t.isReactComponent);
}
function me(e) {
	let t = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.forward_ref") : 60112;
	return e?.$$typeof === t || e?.prototype?.isReactComponent || e?.prototype?.setState || e._forwardRef;
}
function he(e) {
	class t extends o {
		render() {
			return s(e, this.props);
		}
	}
	return t.displayName = e.displayName, t;
}
var P = (e, t) => {
	let n = (e) => {
		let n = `function run () { return ${e}; }`;
		return String(e).includes("return ") && (n = `function runExp () { ${e} }`), F({
			funcBody: n,
			funcName: "run",
			cacheKey: t.cacheKey,
			nodeContext: t.nodeContext,
			storeManager: t.storeManager,
			nodeModel: t.nodeModel
		})();
	};
	try {
		return n(e);
	} catch (t) {
		console.warn(t);
		let n = `[${e}] expression run failed`;
		return console.warn(n), null;
	}
}, F = (e) => {
	let { funcBody: t, funcName: n, nodeContext: r, storeManager: i, $$response: a, nodeModel: o, actionVariableSpace: s } = e, c = n || "anonymous";
	return { [c]: function(...n) {
		try {
			let c = Object.keys(s || {}).sort(), l = t.trim() || "function () {}", u = c.join("\0"), d = `${e.cacheKey ? `${o.id}:${e.cacheKey}` : `${o.id}:${C(l)}`}:${C(u)}`, f = j.get(d);
			if (f) A(D.CODE_EXECUTOR_CACHE_HIT, {
				cacheKey: d,
				nodeId: o.id
			});
			else {
				let e = c.map((e) => `var ${e} = $ACTION_VAR_SPACE[${JSON.stringify(e)}];`), t = `
  var $$$__args__$$$ = Array.from(arguments);
  function $$_run_$$() {
    var __extraParams = $$$__args__$$$.pop();
    var __$$storeManager__ = __extraParams.storeManager;
    var $ALL_NODE_IDS = Array.from(__$$storeManager__.storeMap.keys().filter(Boolean));;
    var $RESPONSE = __extraParams.$$response;;
    var $CTX =  __extraParams.$$context;
    var $$context = $CTX;
    var $PARAMS = $$context.params || {};
    var $PAGE_PROPS = $$context.pageProps || {};
    var $EVENT_PARAMS = $$$__args__$$$[0];
    var $Event = $$$__args__$$$[0];
    var $EVENT = $$$__args__$$$[0];
    var $ARGS = $$$__args__$$$;

    var $ACTION_VAR_SPACE = __extraParams.actionVariableSpace;
    // 新增的变量
    var $N_ID = ${JSON.stringify(o.id)};
    var $NODE_MODAL = __extraParams.nodeModel;
    var $IDS = $ALL_NODE_IDS.reduce(function (res, id) {
        res[id] = id;
        return res;
    }, {});
    var $M = {};
    var $G_STATE = __$$storeManager__.getState('globalState');
    var $STATE = __$$storeManager__.getState($N_ID);
    var $LOOP_DATA = $CTX.loopData;


${se("$ALL_STATE", {
					keyListVar: "$ALL_NODE_IDS ",
					getReadValCode: "return __$$storeManager__.getState(key);"
				})}

${se("$U_STATE", {
					keyListVar: "$ALL_NODE_IDS ",
					getReadValCode: "return function (newVal) { __$$storeManager__.setState(key, newVal); }"
				})}

    $$context.stateManager = __$$storeManager__.getStateSnapshot();
    // action flowACTION_VAR_SPACE 中定义的变量
    ${e.join(";\n")}

    var $$_f_$$ = ${l};

    return $$_f_$$.apply($$_f_$$, $$$__args__$$$);
  }
  return $$_run_$$();
        `;
				A(D.CODE_EXECUTOR_COMPILE_BEFORE, {
					cacheKey: d,
					nodeId: o.id,
					funcBody: l
				}), f = Function(t), A(D.CODE_EXECUTOR_COMPILE_AFTER, {
					cacheKey: d,
					nodeId: o.id,
					codeBody: t
				}), j.size >= fe && j.delete(j.keys().next().value), j.set(d, f);
			}
			return f(...n, {
				$$context: r,
				storeManager: i,
				$$response: a,
				actionVariableSpace: s,
				nodeModel: o
			});
		} catch (e) {
			console.warn(e);
		}
	} }[c];
}, I = (e, t) => {
	let n = {};
	return t.forEach((t, r) => {
		n[t] = e[r];
	}), n;
}, L = (t = []) => {
	let n = {};
	return t.forEach(({ property: t, value: r }) => {
		let i = t.replace("-webkit", "Webkit");
		i = i.replace("-ms", "ms"), i = i.replace("-moz", "Moz"), i = i.replace("-o", "O");
		let a = i.split("-");
		a.length >= 2 && (a = a.map((t, n) => n === 0 ? t : e(t))), n[a.join("")] = r;
	}), n;
}, ge = (e) => {
	let t = "";
	return Object.keys(e || {}).forEach((n) => {
		t += `${n}:${e[n]};`;
	}), t;
}, _e = (e, t) => {
	let n = {};
	return e.forEach((e) => {
		if (e.globalName) {
			let r = t[e.globalName];
			r && (n[e.globalName] = r, r.__esModule && r.default && (n[e.globalName] = r.default));
		}
	}), n;
}, ve = (e, t = 1) => {
	let n = 0, r = e, i = {}, a = {};
	for (; n < t;) Object.keys(r).forEach((e) => {
		i = {
			...i,
			...r[e]
		};
	}), a = i, r = i, i = {}, n += 1;
	return a;
}, ye = (e, t) => {
	let n = [];
	return t.forEach((t) => {
		let r = t.exec(e);
		r?.length && n.push(r[1]);
	}), n;
}, be = (e, t) => {
	let n = {};
	return t.forEach((t) => {
		e[t.name] && (n[t.name] = e[t.name]);
	}), n;
}, xe = (e, t) => be(e, t), Se = (e, t) => be(e, t), R = (e) => e.value.css?.class || `c_${e.id}`, Ce = (e, t) => {
	let n = e.split("."), r, i = t;
	return n.forEach((e) => {
		r = i?.[e], i = r;
	}), r || (() => `Component [${e}] not found`);
}, z = (e, t) => {
	let n = { ...e };
	return n.__proto__ = t, n;
}, we = class {
	storeMap = /* @__PURE__ */ new Map();
	storeDisposeMap = /* @__PURE__ */ new Map();
	stateSnapshotCache;
	invalidateStateSnapshot = () => {
		this.stateSnapshotCache = void 0;
	};
	watchStore(e, t) {
		this.storeDisposeMap.get(e)?.(), this.storeDisposeMap.set(e, t.subscribe((t, n) => {
			let r = Array.from(/* @__PURE__ */ new Set([...Object.keys(n || {}), ...Object.keys(t || {})])).filter((e) => !Object.is(n?.[e], t?.[e]));
			if (A(D.STORE_CHANGED, {
				storeName: e,
				previousState: n,
				state: t
			}), r.length) {
				let i = r.reduce((e, r) => (e[r] = {
					previousValue: n?.[r],
					nextValue: t?.[r]
				}, e), {});
				A(D.STATE_KEYS_UPDATED, {
					storeName: e,
					changedKeys: r,
					changes: i
				});
			}
			this.invalidateStateSnapshot();
		}));
	}
	addStore(e, t) {
		let n = d(t);
		return this.storeMap.set(e, n), this.watchStore(e, n), this.invalidateStateSnapshot(), A(D.STORE_ADDED, { storeName: e }), n.name = e, n;
	}
	setStore(e, t) {
		this.storeMap.set(e, t), this.watchStore(e, t), this.invalidateStateSnapshot();
	}
	removeStore(e) {
		this.storeDisposeMap.get(e)?.(), this.storeDisposeMap.delete(e), this.storeMap.delete(e), this.invalidateStateSnapshot(), A(D.STORE_REMOVED, { storeName: e });
	}
	getStore(e) {
		return this.storeMap.get(e);
	}
	getState(e) {
		return this.storeMap.get(e)?.getState();
	}
	getStateObj(e) {
		return {
			state: this.getState(e),
			updateState: (t) => {
				this.setState(e, t);
			}
		};
	}
	setState(e, t) {
		return this.storeMap.get(e)?.setState(t);
	}
	connect(e, t) {
		let n = this.storeMap.get(e);
		return n ? n.subscribe(t) : (console.warn("store not exits"), () => {});
	}
	getStateSnapshot() {
		if (this.stateSnapshotCache) return A(D.STATE_SNAPSHOT_CACHE_HIT), this.stateSnapshotCache;
		A(D.STATE_SNAPSHOT_CACHE_MISS, { storeCount: this.storeMap.size });
		let e = {};
		return this.storeMap.forEach((t, n) => {
			e[n] = this.getStateObj(n);
		}), this.stateSnapshotCache = e, e;
	}
	destroy() {
		this.storeDisposeMap.forEach((e) => e()), this.storeDisposeMap.clear(), this.storeMap = /* @__PURE__ */ new Map(), this.invalidateStateSnapshot(), A(D.STORE_MANAGER_DESTROYED);
	}
}, Te = class {
	varSpace = /* @__PURE__ */ new Map();
	get(e) {
		return this.varSpace.get(e);
	}
	add(e, t) {
		this.varSpace.set(e, t);
	}
	remove(e) {
		this.varSpace.delete(e);
	}
	destroy() {
		this.varSpace.clear();
	}
	getStateSnapshot() {
		let e = {};
		return this.varSpace.forEach((t, n) => {
			e[n] = t;
		}), e;
	}
}, B = class {
	refMap = /* @__PURE__ */ new Map();
	get(e) {
		return this.refMap.get(e);
	}
	add(e, t) {
		this.refMap.set(e, t);
	}
	remove(e) {
		this.refMap.delete(e);
	}
	destroy() {
		this.refMap.clear();
	}
}, V = "DYNAMIC", H = ["$$context", "$$nodeModel"], U = "ON_DID_RENDER", W = "ON_WILL_DESTROY", Ee = [U, W], G = {
	PROP: "PROP",
	CLASS_NAME: "CLASS_NAME",
	CONDITION: "CONDITION",
	LOOP_DATA: "LOOP_DATA",
	LOOP_KEY: "LOOP_KEY",
	ACTION: "ACTION",
	RUN_CODE: "RUN_CODE",
	JUMP_LINK: "JUMP_LINK",
	CALL_NODE_METHOD: "CALL_NODE_METHOD"
}, K = (e, t) => {
	let n = e;
	return t && (n = { ...e }, n.__proto__ = t || null), n;
}, q = (e, t = {}, ...n) => typeof e == "string" || typeof e == "number" ? String(e) : (H.forEach((n) => {
	n in t && e.__CP_TYPE__ !== "DYNAMIC" && delete t[n];
}), a.createElement(e, t, ...n)), De = (e = {}, n) => {
	let i = [], a = (e, o) => {
		let s = o;
		b(o) && (s = o.value), n(s) ? i.push({
			keyPath: e,
			val: s
		}) : t(s) ? s.forEach((t, n) => {
			a([...e, String(n)], t);
		}) : r(s) && Object.keys(s).forEach((t) => {
			a([...e, t], s[t]);
		});
	};
	return a(["$root"], e), i;
}, J = (e, t) => {
	let n = e.handler, { context: r, storeManager: i } = t;
	return t.actionVariableSpace ||= {}, async function(...e) {
		let a = {}, o = async (n) => {
			let o = n;
			if (o.type === "RUN_CODE") {
				let n = F({
					funcName: "",
					cacheKey: `${G.ACTION}:${o.id}:${G.RUN_CODE}`,
					funcBody: `function() {\n${o.value}\n}`,
					nodeContext: r,
					storeManager: i,
					$$response: t.$$response,
					actionVariableSpace: t.actionVariableSpace,
					nodeModel: t.nodeModel
				}), s;
				s = t.$$response === void 0 ? n(...e) : n(t.$$response, ...e), s?.then ? a[o.id] = await s : a[o.id] = s;
			}
			if (o.type === "JUMP_LINK") {
				let n = Oe(o, t)(...e);
				n?.then ? a[o.id] = await n : a[o.id] = n;
			}
			if (o.type === "REQUEST_API") {
				let { run: n, afterFailedResponse: r, afterSuccessResponse: i } = ke(o, t);
				try {
					let r = n(...e);
					r?.then ? a[o.id] = await r : a[o.id] = r, o.responseVarName && (t.actionVariableSpace[o.responseVarName] = a[o.id]);
					let s = i(a[o.id], ...e);
					return s?.then ? await s : s;
				} catch (e) {
					let t = await r(e);
					return t?.then ? await t : t;
				}
			}
			if (o.type === "CALL_NODE_METHOD") {
				let n = Ae(o, t)(...e);
				n?.then ? a[o.id] = await n : a[o.id] = n, o.returnVarName && (t.actionVariableSpace[o.returnVarName] = a[o.id]);
			}
			if (o.type === "ASSIGN_VALUE") {
				let n = je(o, t), r = [...e];
				t.$$response !== void 0 && (r = [t.$$response, r]);
				let i = n(...r);
				a[o.id] = await i;
			}
		}, s = n[0], c = /* @__PURE__ */ new Set();
		for (; s;) {
			if (c.has(s.id)) return;
			await o(s), c.add(s.id), s = n.find((e) => s?.next && e.id === s?.next);
		}
	};
};
function Oe(e, t) {
	return Y(e.link, t, `${G.ACTION}:${e.id}:${G.JUMP_LINK}`);
}
var Y = (e, t, n) => function(...r) {
	return v(e) ? P(e.value, {
		...t.context,
		nodeContext: t.context,
		storeManager: t.storeManager,
		$$response: t.$$response,
		actionVariableSpace: t.actionVariableSpace,
		cacheKey: n,
		nodeModel: t.nodeModel
	}) : y(e) ? F({
		funcName: e.name || "",
		cacheKey: n,
		funcBody: e.value,
		nodeContext: t.context,
		storeManager: t.storeManager,
		$$response: t.$$response,
		actionVariableSpace: t.actionVariableSpace,
		nodeModel: t.nodeModel
	})(...r) : e;
}, ke = (e, t) => ({
	run: function(...n) {
		let r = "";
		e.apiPath && (r = Y(e.apiPath, t)(...n));
		let i = e.body || {};
		Object.keys(i).forEach((e) => {
			i[e] = Y(i[e], t)(...n);
		});
		let a = e.query || {};
		Object.keys(a).forEach((e) => {
			a[e] = Y(a[e], t)(...n);
		});
		let o = e.header || {};
		Object.keys(o).forEach((e) => {
			o[e] = Y(o[e], t)(...n);
		});
		let s = e.method || "GET";
		return t.context.requestAPI?.({
			url: r,
			method: s,
			header: o,
			body: i,
			query: a
		});
	},
	afterSuccessResponse: async (n, ...r) => e.afterSuccessResponse ? J({
		type: "ACTION",
		handler: [...e.afterSuccessResponse || [], ...e.afterFailedResponse || []]
	}, {
		...t,
		$$response: n
	})(...r) : n,
	afterFailedResponse: async (n, ...r) => e.afterFailedResponse ? J({
		type: "ACTION",
		handler: [...e.afterFailedResponse || [], ...e.afterSuccessResponse || []]
	}, {
		...t,
		$$response: n
	})(...r) : n
}), Ae = (e, t) => (...n) => {
	let r = F({
		funcName: "",
		cacheKey: `${G.ACTION}:${e.id}:${G.CALL_NODE_METHOD}`,
		funcBody: `
      function () {
        var args  = arguments;
        var nodeRef = $$context.nodeRefs.get(${JSON.stringify(e.nodeId)});
        if(nodeRef && nodeRef.current) {
          var func = nodeRef.current[${JSON.stringify(e.methodName)}]?.bind(nodeRef.current);
          var isDev = Boolean(nodeRef.current?.getTargetComponentRef);
          if (isDev) {
            const ins = nodeRef.current.getTargetComponentRef()?.current;
            func = ins?.[${JSON.stringify(e.methodName)}]?.bind(ins);
          }
          if (func) {
            func.apply(null, args);
          }
        }
      }`,
		nodeContext: t.context,
		storeManager: t.storeManager,
		$$response: t.$$response,
		nodeModel: t.nodeModel
	}), i = n;
	return Array.isArray(e.args) && (i = e.args.map((e) => {
		let r = [t.$$response, ...n].filter(Boolean);
		return Y(e, t)(...r);
	})), r(...i);
}, je = (e, t) => async (...n) => {
	let r = Y(e.currentValue, t)(...n), i;
	if (i = r?.then ? await r : r, e.valueType === "STATE") {
		let n = e.targetValueName, r = t.storeManager.getStore(n.nodeId);
		r && r.setState({ [n.keyPath]: i });
	} else e.valueType === "MEMORY" && (t.actionVariableSpace[e.targetValueName] = i);
	return i;
}, X = (e = {}, t) => {
	let { $$context: n, getComponent: i, storeManager: o } = t, s = e, c = (s, l = []) => {
		if (Array.isArray(s)) return s.map((e, t) => c(e, [...l, String(t)]));
		if (b(s)) return c(s.value, l);
		if (te(s)) {
			let r = s.value, o = r.value;
			if (!o) return console.warn("slot value is null, this maybe cause some error, pls check it", e), () => {};
			let c = (e) => {
				let a = `${e.id}-${V}`, o = Z(i(e), e, { ...t }), s = r.params || [];
				return {
					component: (...e) => {
						let t = K({
							params: I(e, s),
							nodeRefs: n.nodeRefs,
							getProps: function() {},
							callEventMethod: function() {}
						}, n);
						return q(o, {
							$$context: t,
							key: a
						});
					},
					key: a
				};
			};
			if (Array.isArray(o)) {
				let e = o?.map((e) => c(e));
				return (...t) => e.map((e) => {
					if (N(e.component)) {
						let t = e.component;
						return a.createElement(t, {
							$$context: n,
							key: e.key
						});
					}
					{
						let n = e.component;
						return n?.(...t);
					}
				});
			}
			return c(o).component;
		}
		if (v(s)) return P(s.value, {
			nodeContext: n,
			storeManager: t.storeManager,
			cacheKey: `${G.PROP}:${l.join(".")}`,
			nodeModel: t.nodeModel
		});
		if (y(s)) {
			let e = s;
			return F({
				funcBody: e.value,
				funcName: e.name || "",
				cacheKey: `${G.PROP}:${l.join(".")}`,
				nodeContext: n,
				storeManager: o,
				nodeModel: t.nodeModel
			});
		}
		if (_(s)) return J(s, {
			context: n,
			storeManager: o,
			actionVariableSpace: {},
			nodeModel: t.nodeModel
		});
		if (r(s)) {
			let e = s;
			b(s) && (e = s.value);
			let t = e, n = {};
			return Object.keys(e).forEach((e) => {
				n[e] = c(t[e], [...l, e]);
			}), n;
		}
		return s;
	}, l = {};
	return Object.keys(s).forEach((e) => {
		let t = s[e];
		l[e] = c(t, [e]);
	}), l;
}, Me = (e, t) => {
	let { runtimeComponentCache: n, $$context: r = {}, getComponent: i, renderMode: a } = t, { $$context: o, idx: s, ...c } = t;
	return typeof e == "string" ? q(e) : ee(e) ? (({ currentNode: t }) => {
		let o = t.value.id, s = null;
		n.get(o) ? s = n.get(o)?.component : (s = Z(i(t), t, { ...c }), !n.get(o) && a !== "design" && n.set(o, { component: s }));
		let l = `${o}-${V}`;
		return q(s, {
			$$context: r,
			$$nodeModel: e,
			key: l
		});
	})({ currentNode: e }) : void 0;
}, Ne = /* @__PURE__ */ new Set([
	"staticVar",
	"methods",
	"updateState",
	"updateGlobalState",
	"getState",
	"getStateById",
	"getStateObj",
	"getStateObjById",
	"getGlobalState",
	"getStaticVar",
	"getStaticVarById",
	"getMethods",
	"getMethodsById",
	"getProps",
	"callEventMethod",
	"storeManager",
	"nodeRefs"
]), Pe = (e) => {
	let t = {};
	for (let n in e) Ne.has(n) || (t[n] = e[n]);
	return t;
}, Z = (e, t, r) => {
	let { storeManager: i, variableManager: o, onGetRef: s, onComponentMount: c, onComponentDestroy: l, refManager: u, processNodeConfigHook: d, requestAPI: f, doc: h } = r, { ..._ } = r;
	class y extends a.Component {
		static __CP_TYPE__ = V;
		_CONDITION = !0;
		_DESIGN_BOX = !1;
		_NODE_MODEL = t;
		_NODE_ID = t.id;
		UNIQUE_ID = `${t.id}_${g()}`;
		targetComponentRef;
		listenerHandler = [];
		storeState;
		storeListenDisposeList = [];
		nodeModelDispose;
		domHeader;
		mediaStyleDomMap = {};
		childElementCache;
		variableSpace;
		nodeName;
		isMounted = !1;
		constructor(e) {
			super(e), this.targetComponentRef = a.createRef(), this.listenerHandler = [], this.state = t.value.state || {};
			let n = t.value.nodeName || t.id;
			t.value.componentName === m.ROOT_CONTAINER && (n = "globalState"), this.nodeName = n;
			let r = i.getStore(n);
			if (!r) this.storeState = i.addStore(n, () => ({ ...t.value.state || {} }));
			else {
				this.storeState = r;
				let e = {
					...t.value.state || {},
					...r.getState()
				};
				r.setState(e), this.state = e;
			}
			let s = this.storeState.subscribe((e) => {
				this.setStateIfChanged(e);
			});
			this.storeListenDisposeList.push(s), this.connectStore();
			let c = o.get(n);
			c ? this.variableSpace = c : (this.variableSpace = {
				staticVar: {},
				methods: {}
			}, o.add(n, this.variableSpace));
		}
		updateState = (e) => {
			this.isMounted && (t.value.componentName === m.ROOT_CONTAINER ? this.setState(e) : this.storeState.setState(e));
		};
		setStateIfChanged(e) {
			this.isMounted && t.value.componentName !== m.ROOT_CONTAINER && this.setState((t) => {
				let r = typeof e == "function" ? e(t) : e;
				return n(t, {
					...t,
					...r
				}) ? null : r;
			});
		}
		connectStore() {
			let e = De(t.props, (e) => !!v(e)), n = De({
				css: t.value.css,
				class: t.value.classNames
			}, (e) => !!v(e)), r = [];
			[...e, ...n].map((e) => {
				let t = e.val, n = ye(t.value, [
					/(?<=context\.stateManager(?:\.|\[["'])?)\w+(?=(?:["']?\])?(?:\.|\[)?["']?state)/gim,
					/\$ALL_STATE(?:\.|(?:\[\s*["']))(\w+)(?=(?:["']\s*\])?)/gim,
					/getStateObj\(["']([^"']+)["']\)/gim,
					/getStateObjById\(["']([^"']+)["']\)/gim
				]);
				r = [...r, ...n], /\$CTX\.globalState|\$\$context\.globalState|\$G_STATE|(?:\$CTX|\$\$context)\.getGlobalState\s*\(/.test(t.value) && r.push("globalState");
			}).filter(Boolean);
			let a = Array.from(new Set(r));
			a.length && a.forEach((e) => {
				if (!e) return;
				i.getStore(e) || (i.addStore(e, () => ({})), console.warn(i, e, "not exits, auto create"));
				let t = i.connect(e, (e) => {
					this.setStateIfChanged(e);
				});
				this.storeListenDisposeList.push(t);
			});
		}
		getStyleDomById = (e) => {
			let t = this.mediaStyleDomMap, n = t[e];
			return n || (n = h.createElement("style"), t[e] = n), n.id = e, n;
		};
		addMediaCSS = () => {
			let e = this.domHeader;
			if (e || (e = h.getElementsByTagName("head")?.[0], this.domHeader = e), !this.domHeader) {
				console.warn("not found header dom");
				return;
			}
			let t = this._NODE_MODEL.value.css;
			t && t.value.forEach((t) => {
				let n = `${this.UNIQUE_ID}_${t.state}`, r = R(this._NODE_MODEL);
				if (t.state !== "normal" && (r = `${r}:${t.state}`), t.text) {
					let i = this.getStyleDomById(n);
					i.innerText = `.${r} { ${t.text} }`, e?.appendChild(i);
				}
				t.media?.length && t.media.forEach((t) => {
					let i = `${n}_${t.type}_${t.value}`, a = this.getStyleDomById(i);
					a.media = `screen and (${t.type}:${t.value}px)`, a.innerHTML = `.${r} { ${t.text || ""} }`, e?.appendChild(a);
				});
			});
		};
		removeMediaCSS = () => {
			let e = this.mediaStyleDomMap;
			Object.keys(e).forEach((t) => {
				this.domHeader?.removeChild(e[t]);
			}), this.mediaStyleDomMap = {};
		};
		rebuildNode = () => {
			this.storeListenDisposeList.forEach((e) => e()), this.storeListenDisposeList = [];
			let e = this.storeState.subscribe((e) => {
				this.setStateIfChanged(e);
			});
			this.storeListenDisposeList.push(e), this.removeMediaCSS(), this.childElementCache = void 0, this.connectStore(), this.addMediaCSS(), this.forceUpdate();
		};
		componentDidMount() {
			this.isMounted = !0, this.addMediaCSS(), s?.(this.targetComponentRef, t, this), c?.(this, t);
			let e = t.value.eventListener?.find((e) => e.name === U);
			e && J(e.func, {
				context: this.createCurrentNodeCtx(),
				storeManager: i,
				actionVariableSpace: {},
				nodeModel: t
			})();
			let n = () => {
				this.isMounted && (M(t.id), i.setStore(t.value.nodeName || t.id, this.storeState), this.storeState.setState({
					...this.state,
					...t.value.state || {}
				}), this.rebuildNode());
			};
			this.nodeModelDispose = t.onChange(n);
		}
		componentWillUnmount() {
			this.storeListenDisposeList.forEach((e) => e()), this.storeListenDisposeList = [], this.nodeModelDispose?.(), this.nodeModelDispose = void 0, this.removeMediaCSS(), l?.(this, t);
			let e = W, n = t.value.eventListener?.find((t) => t.name === e);
			n && J(n.func, {
				context: this.createCurrentNodeCtx(),
				storeManager: i,
				actionVariableSpace: {},
				nodeModel: t
			})();
		}
		transformMethods(e) {
			let { context: n } = e, r = X({ methods: t.value.methods }, {
				$$context: n,
				..._,
				nodeModel: t
			}), i = t.value.methods || [], a = r.methods, o = i.reduce((e, t, n) => (e[t.name] = a[n], e), {});
			n.methods = o, this.variableSpace.methods = Object.assign(this.variableSpace.methods, o);
		}
		processRootContext(e) {
			t.value.componentName === m.ROOT_CONTAINER && (e.globalState = this.state, e.updateGlobalState = this.updateState, e.requestAPI = f, e.getGlobalState = () => this.state);
		}
		processNodeClassName(e, n) {
			let r = t.value.classNames?.map((e, r) => {
				let a = e.name;
				return v(e.status) && P(e.status?.value || "", {
					nodeContext: n,
					nodeModel: t,
					storeManager: i,
					cacheKey: `${G.CLASS_NAME}:${r}`
				}) ? a : "";
			}) || [], a = `${e ?? ""} ${r.join(" ")}`.trim();
			return t.value.css && (a = `${R(t)} ${a}`.trim()), a;
		}
		processNodeStyle(e) {
			return t.value.style ? L(X({ style: t.value.style }, {
				$$context: e,
				..._,
				nodeModel: t
			}).style || []) : {};
		}
		processNodeChild(e, r) {
			let i = [];
			if (e !== void 0) i = Array.isArray(e) ? e : [e];
			else {
				let e = Pe(r), a = {
					nodeId: t.id,
					componentName: t.value.componentName,
					childCount: t.value.children.length,
					contextKeys: Object.keys(e)
				};
				if (this.childElementCache && n(this.childElementCache.contextSignature, e)) return A(D.CHILD_ELEMENT_CACHE_HIT, a), this.childElementCache.children;
				A(D.CHILD_ELEMENT_CACHE_MISS, {
					...a,
					hasCache: !!this.childElementCache
				});
				let o = [];
				t.value.children.forEach((e, t) => {
					let n = Me(e, {
						$$context: r,
						idx: t,
						..._
					});
					o.push(n);
				}), this.childElementCache = {
					contextSignature: e,
					children: o
				}, i = o;
			}
			return i;
		}
		processNodeConditionAndConfigHook(n, r, o) {
			let s = t.value.condition ?? !0;
			typeof s != "boolean" && (s = P(s.value, {
				nodeContext: o || {},
				nodeModel: t,
				storeManager: i,
				cacheKey: G.CONDITION
			}));
			let c = {
				condition: s,
				props: n
			};
			d && (c = d(c, t));
			let l = q(e, c.props, ...r);
			return this._CONDITION = c.condition, c.condition ? l : a.createElement("div", {
				key: n.key,
				style: { display: "none" }
			}, l);
		}
		processNodeEventListener(e) {
			let n = t.value.eventListener, r = {};
			return n?.forEach((n) => {
				if (Ee.includes(n.name)) return;
				let a = J(n.func, {
					context: e,
					storeManager: i,
					actionVariableSpace: {},
					nodeModel: t
				});
				r[n.name] = a;
			}), r;
		}
		createCurrentNodeCtx() {
			let { $$context: e } = this.props, n = t.value.nodeName || t.id, r = t.id, a = {
				state: this.state || {},
				staticVar: this.variableSpace.staticVar,
				updateState: this.updateState,
				storeManager: i,
				getState: () => i.getStateObj(n),
				getStateObj: () => i.getStateObj(n),
				getStateObjById: (e) => i.getStateObj(e),
				stateManager: i.getStateSnapshot(),
				getMethods: () => {
					let e = o.get(r).methods, t = u.get(r).current;
					return z(e, t);
				},
				getMethodsById: (e) => {
					let t = o.get(e).methods, n = u.get(e).current;
					return z(t, n);
				},
				getStaticVar: () => o.get(n).staticVar,
				getStaticVarById: (e) => o.get(e).staticVar,
				callEventMethod: (e, t) => {
					u.get(r).current?.props[e]?.(t);
				},
				getProps: () => u.get(r).current?.props,
				nodeRefs: e.nodeRefs
			};
			return this.processRootContext(a), K(a, e);
		}
		injectEngEnv() {
			let e = {}, n = t.value.injectEnvList || [];
			if (Array.isArray(t.value.injectEnvList)) {
				let t = { [p.COMPONENTS]: r.components };
				n.reduce((e, n) => (e[n] = t[n], e), e);
			}
			return e;
		}
		renderCore() {
			let { $$context: e, ...n } = this.props, r = {
				key: t.id,
				...t.props,
				...n
			}, i = this.createCurrentNodeCtx();
			this.transformMethods({ context: i });
			let a = X(r, {
				$$context: i,
				..._,
				nodeModel: t
			}), o = this.injectEngEnv();
			Object.assign(a, o);
			let s = this.processNodeClassName(a.className, i);
			a.className = s;
			let c = this.processNodeStyle(i);
			a.style = {
				...a?.style || {},
				...c || {}
			};
			let { children: l } = a;
			delete a.children;
			let u = this.processNodeChild(l, i);
			if (a.ref = this.targetComponentRef, t.value.eventListener) {
				let e = this.processNodeEventListener(i);
				a = {
					...a,
					...e
				};
			}
			return this.processNodeConditionAndConfigHook(a, u, i);
		}
		renderLoop() {
			let { $$context: e, ...n } = this.props, r = {
				key: t.id,
				...t.props,
				...n
			}, a = this.createCurrentNodeCtx();
			this.transformMethods({ context: a });
			let o = t.value.loop, s = [];
			if (o && o.open) {
				this.targetComponentRef.current = [];
				let e = o.data || [];
				if (v(o.data)) {
					let n = o.data;
					e = P(n.value, {
						nodeContext: a || {},
						storeManager: i,
						nodeModel: t,
						cacheKey: G.LOOP_DATA
					}) || [];
				}
				return s = e.map((...e) => {
					let n = e[1], s = I(e, [o.forName || "item", o.forIndex || "index"]), c = "loopData";
					o.name && (c = `${c}${o.name}`);
					let l = K({
						[c]: s,
						nodeRefs: a.nodeRefs,
						getProps: function() {},
						callEventMethod: function() {}
					}, a), u = X(r, {
						$$context: l,
						..._,
						nodeModel: t
					}), d = this.injectEngEnv();
					Object.assign(u, d);
					let f = this.processNodeClassName(u.className, l);
					u.className = f;
					let p = this.processNodeStyle(l);
					u.style = {
						...u?.style || {},
						...p || {}
					};
					let { children: m } = u;
					delete u.children;
					let h = this.processNodeChild(m, l);
					if (u.key = `${u.key}-${n}`, v(o.key)) {
						let e = o.key, n = P(e.value, {
							nodeContext: l || {},
							storeManager: i,
							nodeModel: t,
							cacheKey: G.LOOP_KEY
						});
						u.key += `-${n}`;
					}
					if (u.ref = (e) => {
						this.targetComponentRef.current = this.targetComponentRef.current || [], this.targetComponentRef.current[n] = e;
					}, t.value.eventListener) {
						let e = this.processNodeEventListener(l);
						u = {
							...u,
							...e
						};
					}
					return this.processNodeConditionAndConfigHook(u, h, l);
				}), s;
			}
		}
		render() {
			let e = t.value.loop;
			return e && e.open ? this.renderLoop() : this.renderCore();
		}
	}
	return y.displayName = `${t.value.componentName}Dynamic`, y;
}, Fe = class {
	renderMode = "normal";
	components = {};
	storeManager = new we();
	variableManager = new Te();
	runtimeComponentCache = /* @__PURE__ */ new Map();
	onGetRef;
	onGetComponent;
	onComponentMount;
	refManager = new B();
	onComponentDestroy;
	pageRenderCache;
	processNodeConfigHook;
	getComponent(e) {
		let t = e.value.componentName, n = Ce(t, this.components);
		return me(n) || (n = he(n), this.components[t] = n), this.onGetComponent && (n = this.onGetComponent?.(n, e)), n;
	}
	pageRender(e, { components: t, onGetRef: n, refManager: r, pageProps: i, $$context: a = {
		nodeRefs: r,
		getProps: function() {},
		callEventMethod: function() {}
	}, onGetComponent: o, onComponentMount: s, onComponentDestroy: c, renderMode: l, debugOption: u, processNodeConfigHook: d, requestAPI: f, doc: p }) {
		this.renderMode = l, this.components = t, this.onGetRef = n, this.onGetComponent = o, this.onComponentMount = s, this.onComponentDestroy = c, this.processNodeConfigHook = d, this.refManager = r, this.requestAPI = f, de(u);
		let m = e.value.componentsTree, h = this.pageRenderCache, g = l !== "design" && h?.pageModel === e && h.components === t && h.rootNode === m && h.onGetRef === n && h.onGetComponent === o && h.onComponentMount === s && h.onComponentDestroy === c && h.processNodeConfigHook === d && h.requestAPI === f && h.renderMode === l && h.doc === p, _, v;
		if (g) _ = h.component, v = h.baseProps;
		else {
			let r = m.value.id;
			this.runtimeComponentCache.delete(r), _ = Z(this.getComponent(m), e.value.componentsTree, {
				storeManager: this.storeManager,
				variableManager: this.variableManager,
				runtimeComponentCache: this.runtimeComponentCache,
				getComponent: this.getComponent.bind(this),
				refManager: this.refManager,
				onGetRef: this.onGetRef,
				processNodeConfigHook: d,
				onComponentMount: s,
				onComponentDestroy: c,
				renderMode: l,
				requestAPI: f,
				components: this.components,
				doc: p
			}), l !== "design" && this.runtimeComponentCache.set(r, { component: _ }), v = {};
			let i = m.props;
			Object.keys(i).forEach((e) => {
				v[e] = i[e].value;
			}), Object.assign(v, e.value.props), this.pageRenderCache = {
				pageModel: e,
				components: t,
				rootNode: m,
				component: _,
				baseProps: v,
				onGetRef: n,
				onGetComponent: o,
				onComponentMount: s,
				onComponentDestroy: c,
				processNodeConfigHook: d,
				requestAPI: f,
				renderMode: l,
				doc: p
			};
		}
		let y = {
			...v,
			...i
		};
		return y.$$context = {
			...a,
			pageProps: i || {}
		}, q(_, y);
	}
	getPageStorage() {
		return this.storeManager.getState("globalState") || {};
	}
	updatePageStorage(e) {
		let t = this.storeManager.getStore("globalState");
		if (t) {
			t.setState(e);
			return;
		}
		this.storeManager.addStore("globalState", () => ({ ...e }));
	}
	requestAPI = async (e) => {
		throw console.log(e), Error("Need to implement requestAPI for Render");
	};
	clear(e) {
		this.runtimeComponentCache.clear(), this.pageRenderCache = void 0, M(), A(D.RENDER_ADAPTER_CLEARED, e), e?.preserveState || (this.storeManager.destroy(), this.variableManager.destroy());
	}
}, Q = () => oe(new Fe()), Ie = Q();
Ie.createInstance = Q;
//#endregion
//#region src/commonComponent/index.tsx
var $ = (e) => {
	let t = {};
	return e.forEach((e) => {
		t[e.key] = e.value;
	}), t;
}, Le = ne.reduce((e, t) => (e[t] = ({ children: e, $$attributes: n = [], ...r }) => {
	let i = e;
	Array.isArray(e) || (i = [e]);
	let o = {
		boxSizing: "border-box",
		...r.style || {}
	};
	return a.createElement(t, {
		...r,
		...$(n),
		style: o
	}, ...i);
}, e), {}), Re = ({ children: e, width: t, height: n, $$attributes: r = [], ...i }) => {
	let o = e;
	Array.isArray(e) || (o = [e]), o = o.filter((e) => e !== void 0);
	let { style: s = {}, ...c } = $(r), l = {
		height: n,
		width: t,
		boxSizing: "border-box",
		...s,
		...i.style || {}
	};
	return a.createElement("div", {
		...i,
		...c,
		style: l
	}, ...o);
}, ze = ({ afterMount: e, beforeDestroy: t, $$attributes: n = [], ...r }) => {
	c(() => (e?.(r), () => {
		t?.(r);
	}), []);
	let i = {
		boxSizing: "border-box",
		...r.style || {}
	};
	return a.createElement("canvas", {
		...r,
		...$(n),
		style: i
	});
}, Be = ({ children: e, $$attributes: t = [], ...n }) => {
	let r = e;
	Array.isArray(e) || (r = [e]);
	let i = {
		boxSizing: "border-box",
		...n.style || {}
	};
	return a.createElement("img", {
		...n,
		...$(t),
		style: i
	}, ...r);
}, Ve = ({ children: e, $$attributes: t = [], ...n }) => {
	let r = e;
	Array.isArray(e) || (r = [e]);
	let i = {
		boxSizing: "border-box",
		...n.style || {}
	};
	return a.createElement("video", {
		...n,
		...$(t),
		style: i
	}, ...r);
}, He = ({ children: e, $$attributes: t = [], ...n }) => {
	let r = e;
	Array.isArray(e) || (r = [e]);
	let i = {
		boxSizing: "border-box",
		...n.style || {}
	};
	return a.createElement("audio", {
		...n,
		...$(t),
		style: i
	}, ...r);
}, Ue = ({ $$attributes: e = [], content: t, ...n }) => {
	let r = {
		boxSizing: "border-box",
		...n.style || {}
	};
	return a.createElement("span", {
		...n,
		...$(e),
		style: r
	}, t);
}, We = ({ children: e, $$attributes: t = [], afterMount: n, beforeDestroy: r, style: i, ...o }) => {
	let s = e;
	Array.isArray(e) || (s = [e]);
	let c = {
		boxSizing: "border-box",
		...i || {}
	};
	return a.createElement("div", {
		...o,
		...$(t),
		style: c
	}, ...s);
}, Ge = ({ children: e, $$attributes: t = [], htmlTag: n = "div", ...r }) => {
	let i = e;
	Array.isArray(e) || (i = [e]);
	let { style: o = {}, ...s } = $(t), c = {
		boxSizing: "border-box",
		...o,
		...r.style || {}
	};
	return a.createElement(n, {
		...r,
		...s,
		style: c
	}, ...i);
}, Ke = {
	RootContainer: ({ children: e }) => e,
	...Le,
	CContainer: We,
	CVideo: Ve,
	CAudio: He,
	CBlock: Re,
	CImage: Be,
	CText: Ue,
	CCanvas: ze,
	CNativeTag: Ge
}, qe = class extends a.Component {
	adapter;
	ownsAdapter;
	refManager;
	dynamicComponentInstanceMap = /* @__PURE__ */ new Map();
	componentsSource;
	finalComponents;
	contextSource;
	contextWithRefs;
	defaultContext = {
		getProps: () => void 0,
		callEventMethod: () => void 0
	};
	constructor(e) {
		super(e);
		let t = e.adapter.createInstance?.();
		this.adapter = t || e.adapter, this.ownsAdapter = !!t, this.state = { pageModel: e.pageModel || new f(e.page) }, this.refManager = new B();
	}
	getPageModel() {
		return this.state.pageModel;
	}
	componentDidMount() {
		let { render: e } = this.props;
		e && (e.ref.current = this), window.parent && (window.parent.__CB_RENDER_WIN__ = window);
	}
	componentWillUnmount() {
		this.refManager.destroy(), this.ownsAdapter && this.adapter.clear();
	}
	onGetRef = (e, t, n) => {
		this.props.onGetRef?.(e, t, n), this.dynamicComponentInstanceMap.set(t.id, n), this.refManager.add(t.value.refId || t.id, e);
	};
	render() {
		let { props: e } = this, { onGetComponent: t, onComponentDestroy: n, onComponentMount: r } = e, { adapter: i } = this, { pageModel: a } = this.state;
		if (!a) return console.warn("pageModel is null"), null;
		(e.renderMode === "design" || !this.finalComponents || this.componentsSource !== e.components) && (this.componentsSource = e.components, this.finalComponents = {
			...Ke,
			...e.components
		});
		let o = this.props.$$context || this.defaultContext;
		this.contextSource !== o && (this.contextSource = o, this.contextWithRefs = {
			...o,
			nodeRefs: this.refManager
		});
		let s = this.props.doc;
		typeof window < "u" && (s = this.props.doc || window.document);
		let c = i.pageRender(a, {
			libs: {},
			components: this.finalComponents,
			debugOption: e.debugOption,
			pageProps: e.pageProps,
			refManager: this.refManager,
			onGetRef: this.onGetRef,
			onGetComponent: t,
			onComponentMount: r,
			onComponentDestroy: n,
			$$context: this.contextWithRefs,
			renderMode: e.renderMode || "normal",
			requestAPI: e.requestAPI ?? i.requestAPI,
			processNodeConfigHook: e.processNodeConfigHook,
			doc: s
		});
		return A(D.RENDER_PAGE_RENDERED, { renderMode: e.renderMode || "normal" }), c;
	}
	getPageStorage = () => this.adapter.getPageStorage?.() || {};
	updatePageStorage = (e) => {
		this.adapter.updatePageStorage?.(e);
	};
	rerender = (e, t) => {
		let n = t?.force ?? !1;
		if (A(D.RENDER_PAGE_RERENDER, { force: n }), e?.nodeType === "PAGE" && e) this.adapter.clear({ preserveState: !n }), this.setState({ pageModel: e });
		else if (r(e) && h(e)) {
			let t = e;
			this.adapter.clear({ preserveState: !n }), this.setState({ pageModel: new f(t, { materials: this.state.pageModel.materialsModel.rawValue }) });
		}
	};
}, Je = () => {
	let e = u(null);
	return l(() => ({
		ref: e,
		rerender: function(...t) {
			e.current && e.current.rerender(...t);
		},
		getPageStorage: function() {
			return e.current?.getPageStorage() || {};
		},
		updatePageStorage: function(t) {
			e.current?.updatePageStorage(t);
		}
	}), []);
}, Ye = class extends a.Component {
	constructor(e) {
		super(e), this.state = {
			hasError: !1,
			error: ""
		};
	}
	static getDerivedStateFromError(e) {
		return {
			hasError: !0,
			error: e
		};
	}
	componentDidCatch(e, t) {
		this.props.onError?.(t);
	}
	onDoubleClick = () => {
		this.setState({
			hasError: !1,
			error: null
		});
	};
	render() {
		if (this.state.hasError) {
			let { onDoubleClick: e } = this, t = this.props.node.value;
			console.error(this.props.node, this.props.children);
			let n = a.createElement("div", { style: {
				backgroundColor: "rgb(255 206 215 / 13%)",
				padding: "5px",
				color: "#ff0000b0",
				textAlign: "center",
				fontSize: "12px"
			} }, "Render error, node id: ", t.id, ", node name：", t.title, " component name：", t.title || t.componentName, a.createElement("p", null, "msg: ", String(this.state.error)), a.createElement("button", {
				onDoubleClick: e,
				style: {
					border: "1px solid rgba(100,100,100,0.1)",
					backgroundColor: "#fff",
					padding: "5px 10px",
					borderRadius: "2px",
					color: "gray",
					cursor: "pointer",
					marginTop: "5px"
				}
			}, "double click to refresh"), a.createElement("div", { style: { display: "none" } }));
			return a.createElement(this.props.targetComponent, { onlyRenderChild: !0 }, n);
		}
		return this.props.children;
	}
}, Xe = class {
	instanceMap = /* @__PURE__ */ new Map();
	get(e) {
		return this.instanceMap.get(e);
	}
	add(e, t) {
		let n = this.instanceMap.get(e);
		n ? n.push(t) : this.instanceMap.set(e, [t]);
	}
	remove(e, t) {
		let n = this.instanceMap.get(e);
		if (t !== void 0 && Array.isArray(n)) {
			let r = n.filter((e) => e !== t);
			this.instanceMap.set(e, r);
		} else this.instanceMap.delete(e);
	}
	destroy() {
		this.instanceMap.clear();
	}
}, Ze = (e) => {
	let { node: t } = e, { placeholder: n, height: i, width: o, style: s } = l(() => {
		let e = t.isContainer();
		return r(e) ? e : {
			placeholder: "Drag the component to place it",
			width: "100%",
			height: "100%",
			style: {}
		};
	}, [t]);
	return a.createElement("div", { style: {
		margin: 0,
		padding: "0 16px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "rgba(44, 115, 253, 0.04)",
		border: "1px dashed rgba(44, 115, 253, 0.42)",
		borderRadius: "3px",
		fontSize: "13px",
		fontWeight: 500,
		letterSpacing: "0.01em",
		color: "rgba(44, 83, 145, 0.72)",
		cursor: "default",
		minHeight: "50px",
		width: o,
		height: i,
		boxSizing: "border-box",
		transition: "background-color 0.15s ease, border-color 0.15s ease",
		...s
	} }, n);
}, Qe = class extends a.Component {
	instanceManager = new Xe();
	renderRef;
	dropPlaceholder = Ze;
	_components = {};
	constructor(e) {
		super(e), this._components = Object.assign(this._components, this.props.components), this.renderRef = a.createRef(), e.dropPlaceholder && (this.dropPlaceholder = e.dropPlaceholder);
	}
	updateComponents(e = {}) {
		this._components = Object.assign(this._components, e), this.forceUpdate();
	}
	componentDidMount() {
		window.__CHAMN_RENDER_MODE = "DESIGN", this.updateComponents(this.props.components), this.props.onMount?.(this);
	}
	getPageModel() {
		return this.renderRef.current?.state.pageModel;
	}
	onGetComponent = (e, n) => {
		let r = this, i = e, o = n.material?.value.advanceCustom?.wrapComponent;
		o && (i = o(e, {
			node: n,
			ctx: window.__C_ENGINE_DESIGNER_PLUGIN_CTX__
		}));
		class s extends a.Component {
			_DESIGN_BOX = !0;
			_NODE_MODEL = n;
			_NODE_ID = n.id;
			_UNIQUE_ID = `${n.id}_${g()}`;
			_STATUS;
			_design_target_component = a.createRef();
			_dom;
			componentDidMount() {
				r.instanceManager.add(n.id, this);
			}
			getTargetComponentRef() {
				return this._design_target_component;
			}
			componentWillUnmount() {
				this._STATUS = "DESTROY", r.instanceManager.remove(n.id, this);
			}
			getDom() {
				return n.material?.value.advanceCustom?.autoGetDom ?? !0 ? this._dom?.children?.[0] : this._dom;
			}
			render() {
				let { children: e = [], onlyRenderChild: o, ...s } = this.props, c = {
					...s,
					ref: (e) => {
						this._design_target_component.current = e;
					}
				}, l = e;
				if (t(e) || (l = [e]), !l.filter(Boolean).length && (n.isContainer() || n.value.componentName === m.ROOT_CONTAINER)) {
					let e = n.material?.value.advanceCustom?.dropPlaceholder;
					l.push(a.createElement(e || r.dropPlaceholder, { node: n }));
				}
				if (o) return l;
				if (n.material?.value.advanceCustom?.autoGetDom ?? !0) {
					let e = a.createElement(i, s, ...l);
					return a.createElement("div", {
						style: { display: "contents" },
						ref: (e) => {
							this._dom = e;
						}
					}, e);
				}
				return a.createElement(i, {
					...c,
					$SET_DOM: (e) => {
						this._dom = e;
					}
				}, ...l);
			}
		}
		return a.forwardRef(function(e, t) {
			return a.createElement(Ye, {
				node: n,
				targetComponent: s
			}, a.createElement(s, {
				ref: t,
				...e
			}));
		});
	};
	rerender(e, t) {
		return this.renderRef.current?.rerender(e, t);
	}
	getInstancesById(e, t) {
		let n = [...this.instanceManager.get(e) || []];
		return t !== void 0 && (n = n.filter((e) => t === e?._UNIQUE_ID)), n;
	}
	getInstanceByDom(e) {
		let t = $e(e);
		return t && et(t)?.stateNode || null;
	}
	getDomsById(e, t) {
		let n = this.getInstancesById(e), r = [];
		return n?.forEach((e) => {
			if (e?._STATUS === "DESTROY") return;
			let n = e.getDom();
			if (n && !(n instanceof Text)) {
				if (t) {
					let e = Array.from(n.querySelectorAll?.(t) || []);
					r.push(...e);
				} else r.push(n);
			}
		}), r;
	}
	getDomRectById(e, t) {
		return this.getDomsById(e, t).map((e) => e?.getBoundingClientRect()).filter(Boolean);
	}
	render() {
		let { props: e, onGetComponent: t } = this, { render: n, ...o } = e;
		return n && (n.ref.current = this), a.createElement(qe, {
			onGetComponent: t,
			...o,
			components: this._components,
			processNodeConfigHook: (e, t) => {
				if (t.nodeType !== "NODE") return e;
				let { props: n, condition: a } = e, o = { ...n }, s = t.value.configure?.devState || {}, c = t.material?.value.fixedProps;
				if (c !== void 0) {
					if (r(c)) o = {
						...o,
						...c
					};
					else if (typeof c == "function") {
						let e = c(o);
						o = {
							...o,
							...e
						};
					}
				}
				let l = a;
				return s.condition === !1 && (l = s.condition), {
					props: i(o, s.props || {}),
					condition: l
				};
			},
			renderMode: "design",
			ref: this.renderRef
		});
	}
}, $e = (e) => {
	if (!e) return null;
	let t = Object.keys(e).find((e) => e.startsWith("__reactInternalInstance$") || e.startsWith("__reactFiber$")) || "";
	return t ? e[t] : $e(e.parentElement);
}, et = (e) => e ? e?.stateNode?._DESIGN_BOX ? e : et(e.return) : null, tt = () => {
	let e = u(null);
	return {
		ref: e,
		rerender: function(...t) {
			e.current && e.current.rerender(...t);
		},
		getInstancesById(t, n) {
			return e.current?.getInstancesById(t, n) || [];
		},
		getInstanceByDom(t) {
			return e.current?.getInstanceByDom(t) || null;
		},
		getDomsById(t, n) {
			return e.current?.getDomsById(t, n) || [];
		},
		getDomRectById(t, n) {
			return e.current?.getDomRectById(t, n) || [];
		}
	};
}, nt = class {
	assets;
	loadStatus;
	win = window;
	_onSuccessList = [];
	_onErrorList = [];
	constructor(e, t) {
		this.assets = JSON.parse(JSON.stringify(e || [])), this.loadStatus = "INIT", t?.window && (this.win = t.window);
	}
	load(e) {
		let t = this.assets || [], n = [];
		for (let r = 0; r < t.length; r++) {
			let i = t[r];
			i.id ||= g(), n.push(i.id);
			let a = i.resources.map((e) => e.src);
			a.length && re(a, i.id, {
				async: e?.async ?? !1,
				before: (e, t) => (this.win.document.body.appendChild(t), !1)
			});
		}
		return new Promise((e, r) => {
			if (t.length === 0) {
				this._onSuccessList.forEach((e) => e()), e("");
				return;
			}
			re.ready(n, {
				success: () => {
					this._onSuccessList.forEach((e) => e()), e("");
				},
				error: (e) => {
					this._onErrorList.forEach((t) => t(e)), r(e);
				}
			});
		});
	}
	onSuccess(e) {
		return this._onSuccessList.push(e), this;
	}
	onError(e) {
		return this._onErrorList.push(e), this;
	}
};
//#endregion
export { nt as AssetLoader, G as CODE_CACHE_KEY, T as CODE_MAP_MSG, w as CODE_MAP_MSG_GLOBAL_NAME, Xe as ComponentInstanceManager, V as DYNAMIC_COMPONENT_TYPE, Ze as DefaultDropPlaceholder, Fe as DefineReactAdapter, Qe as DesignRender, Ee as INNER_EVENT_LIST, H as InnerPropList, U as ON_DID_RENDER, W as ON_WILL_DESTROY, D as RENDER_DEBUG_CODE, E as RENDER_DEBUG_PREFIX, Ie as ReactAdapter, B as RefManager, qe as Render, me as canAcceptsRef, M as clearCodeExecutorCache, _e as collectVariable, he as compWrapper, F as convertCodeStringToFunction, Q as createReactAdapter, A as debugLog, Ce as findComponentByChainRefer, ve as flatObject, L as formatSourceStylePropertyName, oe as getAdapter, ge as getCSSTextValue, xe as getComponentsLibs, z as getInheritObj, ye as getMatchVal, R as getNodeCssClassName, I as getObjFromArrayMap, Se as getThirdLibs, pe as isClass, P as runExpression, de as setDebugOption, N as shouldConstruct, tt as useDesignRender, Je as useRender };

//# sourceMappingURL=index.es.js.map